<template lang="pug">
	.mt-2
		.card
			.table-responsive
				table.table.table-condensed.table-striped.m-0
					thead.bg-dark.text-white
						tr
							td(style='cursor:pointer;' @click="setOrden('ContratoID')")
								| Contrato
								.ml-2(style='position:relative;display:inline-block;' v-if="order === 'ContratoID'")
									span.fa(:class="(this.direccion === 'desc') ? 'fa-caret-down' : 'fa-caret-up'")
							td(style='cursor:pointer;' @click="setOrden('FechaVencimiento')")
								| Vencimiento
								.ml-2(style='position:relative;display:inline-block;' v-if="order === 'FechaVencimiento'")
									span.fa(:class="(this.direccion === 'desc') ? 'fa-caret-down' : 'fa-caret-up'")
							td(style='cursor:pointer;' @click="setOrden('ClienteNombre')")
								| Cliente
								.ml-2(style='position:relative;display:inline-block;' v-if="order === 'ClienteNombre'")
									span.fa(:class="(this.direccion === 'desc') ? 'fa-caret-down' : 'fa-caret-up'")
							td(style='cursor:pointer;' @click="setOrden('AgenteNombre')")
								| Agente
								.ml-2(style='position:relative;display:inline-block;' v-if="order === 'AgenteNombre'")
									span.fa(:class="(this.direccion === 'desc') ? 'fa-caret-down' : 'fa-caret-up'")
							td(style='cursor:pointer;' @click="setOrden('Importe')")
								| Importe
								.ml-2(style='position:relative;display:inline-block;' v-if="order === 'Importe'")
									span.fa(:class="(this.direccion === 'desc') ? 'fa-caret-down' : 'fa-caret-up'")
							td(style='cursor:pointer;' @click="setOrden('Importe')")
								| Forma de pago
								.ml-2(style='position:relative;display:inline-block;' v-if="order === 'FormaDePago'")
									span.fa(:class="(this.direccion === 'desc') ? 'fa-caret-down' : 'fa-caret-up'")
							td Estado
							td
					tbody
						tr(v-for='r in resultadosProcesados' :key='r.ID_cobro')
							td
								span.tituloContrato(@click="ContratoID=r.ContratoID") {{r.ContratoID}} / {{r.ContratoTitulo}}
							td {{new Date(parseInt(r.FechaVencimiento) * 1000) | moment(&apos;DD-MM-YYYY&apos;)}}
							td
								span.tituloCliente(@click="ClienteID = r.ClienteID") {{r.ClienteNombre}}
							td {{r.AgenteNombre}}
							td {{r.ImporteTotal | currency(&apos;&apos;)}} &euro;
							td {{r.FormaDePago}}
							td(style="font-size:1.2em;")
								span(v-if="r.Estado === 'Pagado'")
									div.badge.badge-success.p-2 Pagado
								span(v-else)
									div.badge.badge-danger.p-2 Pendiente
							td.text-right
								button.btn.btn-sm.btn-warning(@click='verCobro(r)', v-if="permisos.cobros_crearCobros || r.Estado !== 'Pendiente'")
									span.fa.fa-edit(v-if="r.Estado === 'Pendiente'")
									span.fa.fa-file-o(v-else)
				.card-body.bg-dark.text-white
					.row.text-center
						.col
							b Importe cobrado:
							br
							span(style="font-size:2em;") {{totalPagado | currency('')}} €
						.col
							b Importe Pendiente:
							br
							span(style="font-size:2em;") {{totalPendiente | currency('')}} €
		modal(:max-width="1600", v-if='ContratoID', :top="10")
			.card.text-left
				.card-header
					button.close(@click="ContratoID=null") &times;
				.card-body
					VisorContrato(:ContratoID="ContratoID")
		EditarCliente(v-if="ClienteID", @cerrar="ClienteID = null", :id-cliente="ClienteID")
</template>


<script>
import VisorContrato from '../../../../mis-contratos/vue/components/visor-contrato/visor-contrato.vue'
import EditarCliente from '../../../../gestion-clientes/vue/components/editor/editor.vue'
import { mapGetters } from 'vuex'
export default {
	name: 'resultados-cobros',
	props: ['resultados'],
	components: {
		VisorContrato,
		EditarCliente
	},
	data: function () {
		return {
			order: 'fecha_cobro',
			direccion: 'desc',
			ContratoID: null,
			ClienteID: null
		}
	},

	computed: {
		...mapGetters({
			permisos: 'permisos/permisos'
		}),
		resultadosProcesados () {
			return _.orderBy(this.resultados, [this.order], [this.direccion])
		},

		totalPagado () {
			let importe = 0
			for (let i = 0; i < this.resultados.length; i++) {
				const r = this.resultados[i]
				if (r.Estado === 'Pagado') {
					importe = importe + r.ImporteTotal
				}
			}

			return this.round(importe)
		},

		totalPendiente () {
			let importe = 0
			for (let i = 0; i < this.resultados.length; i++) {
				const r = this.resultados[i]
				if (r.Estado === 'Pendiente') {
					importe = importe + r.ImporteTotal
				}
			}

			return this.round(importe)
		},

		importeTotal () {
			let total = 0

			for (let i = 0; i < this.resultados.length; i++) {
				total = total + parseFloat(this.resultados[i].importeTotal)
			}

			return total
		},

		netoTotal () {
			let total = 0

			for (let i = 0; i < this.resultados.length; i++) {
				total = total + parseFloat(this.resultados[i].netoAgente)
			}

			return total
		}
	},

	methods: {
		redondea (importe) {
			return _.round(importe, 2)
		},
		setOrden (columna) {
			if (columna === this.order) {
				this.direccion = (this.direccion === 'asc') ? 'desc' : 'asc'
				return
			}

			this.order = columna
			this.direccion = 'asc'
		},

		verCobro (cobro) {
			this.$emit('ver', cobro)
		},

		eliminaCobro (cobro) {
			this.$emit('eliminar', cobro)
		}
	}
}
</script>


<style scoped>
.tituloContrato {
	color: darkblue;
	cursor: pointer;
}

.tituloContrato:hover {
	font-weight: bold;
}

.tituloCliente {
	cursor: pointer;
}

.tituloCliente:hover {
	color: darkred;
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/modulos/facturacion-cobros/vue/components/cobros/resultados.vue